import { CustomFormFormTypeEnum } from "../../../../../services";
import * as Yup from "yup";
import { createMapper } from "../../../../../utils/utils";

export const FORM_BUILDER_INIT_VALS = {
  uuid: "",
  name: "",
  formType: "CUSTOM_QUESTIONNAIRE",
  speciality: undefined,
  display: "form",
  components: [],
};

export type FormBuilderInitialValues = {
  uuid?: string;
  name: "";
  formType?: CustomFormFormTypeEnum;
  specialities?: { [k: string]: string };
  components?: any;
};

export const FORM_INITIAL_VALUES: FormBuilderInitialValues = {
  uuid: undefined,
  name: "",
  formType: undefined,
  specialities: undefined,
};

export const FORM_VALIDATION_SCHEMA = Yup.object({
  // speciality: Yup.string().required().label("Specialty"),
  // specialities: Yup.array()
  //   .min(1, "Specialties is a required field")
  //   .required()
  //   .label("Specialties"),
  name: Yup.string().required().label("Name"),
  formType: Yup.string().required().label("Form Type"),
});

export const FORM_TYPE_LIST = [
  { label: "Visit Notes", value: "VISIT_NOTES" },
  { label: "Custom Questionnaire", value: "CUSTOM_QUESTIONNAIRE" },
  { label: "Review Of System (ROS)", value: "REVIEW_OF_SYSTEM" },
  { label: "Physical Exam (PE)", value: "PHYSICAL_EXAM" },
  { label: "Macros", value: "MICROS" },
  { label: "Annotable Image", value: "ANNOTABLE_IMAGE" },
  { label: "Order Set", value: "ORDER_SET" },
  // { label: "Email", value: "EMAIL" },
  // { label: "SMS", value: "SMS" },
  { label: "Intake Form", value: "INTAKE_FORM" },
  { label: "Consent Form", value: "CONSENT_FORM" },
];

export const TEMPLATE_TYPE_LIST = [
  { label: "Review Of System (ROS)", value: "ROS" },
  { label: "Physical Exam (PE)", value: "PHYSICAL" },
  { label: "Macros", value: "MACROS" },
  { label: "Email", value: "EMAIL" },
  { label: "SMS", value: "SMS" },
  { label: "Care Plan", value: "CARE_PLAN" },
];

export const TEMPLATE_TYPE_LIST_MAPPER = createMapper(TEMPLATE_TYPE_LIST);

export const FORM_TYPE_MAPPER = FORM_TYPE_LIST.reduce((obj, item) => {
  obj[item.value] = item.label;
  return obj;
}, {} as Record<string, string>);

export type FormActionValue = "view" | "update" | "make_copy" | "archive";

export const FORM_ACTION_MENU_ITEMS = [
  { value: "view", label: "View" },
  { value: "update", label: "Update" },
  { value: "make_copy", label: "Make a Copy" },
  { value: "archive", label: "Archive" },
];
